import * as React from 'react';
import { Body2 } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import builderImg from './assets/builder.png';
import sellerImg from './assets/seller.png';
import * as styles from './SellersBanner.css';

export interface ISellersBannerProps {
  type: 'builder' | 'seller';
  isMultipleSellers?: boolean;
  onClick?(): void;
}

export const SellersBanner: React.FC<ISellersBannerProps> = ({ type, isMultipleSellers, onClick }) => (
  <div className={styles['container']} onClick={onClick}>
    <img alt={type} className={styles['image']} src={type === 'builder' ? builderImg : sellerImg} />
    {type === 'builder' && <Body2>Рассказываем, почему застройщиков несколько</Body2>}
    {type === 'seller' && (
      <Body2>Рассказываем, почему здесь агентств{isMultipleSellers ? 'а' : 'о'} недвижимости</Body2>
    )}
    <div className={styles['arrow']}>
      <IconActionChevronRight16 color="icon-main-default" />
    </div>
  </div>
);
